import React from "react";
import { Col, Row } from "react-bootstrap";
import Contact from "./Contact";
import emailBg from "../../images/mail.gif";
import logoRocket from "./../../images/icons/rocket.gif";
import logo from "./../../images/icons/got.gif";

const ContactLink = () => {
  return (
   <div>
    <Row
      xs={1}
      md={3}
      className="my-2 d-flex justify-content-center align-items-center "
    >
      <Col>
        <div className=" d-flex justify-content-center align-items-center">
        <h3 className="text-center py-3 ">Contact Me</h3>
        <img className="ms-1" src={logoRocket} width="90px" alt="" />
        </div>
        <Contact></Contact>
      </Col>
      <Col>
        <img className="w-100" src={emailBg} alt="" />
      </Col>

    </Row>

    <div className="mt-5 fixed-bottom">
    <h6 className="text-center mt-3">
    Copyright <i class="far fa-copyright"></i> {new Date().getFullYear()}{" "}
          by <span className="text-success">Shahriar</span> All Rights Reserved<img className="ms-1" src={logo} width="40px" alt="" />
        </h6>
    </div>
    </div>
  );
};

export default ContactLink;
